module.exports = __webpack_public_path__ + "media/newstyle/images/twitter-share-pink-da5256999c840ce5d0ab37770af260b5.svg";